import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import { GRL_URL } from 'src/utils/pnd/PndConstants';
import { isNumber, mobileNoFormat, mobileNoLength, validateUaeLandline } from 'src/utils/validationUtils';
import renderField from 'src/shared/components/form/renderField';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import BadgeIcon from '@mui/icons-material/Badge';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SaveIcon from '@mui/icons-material/Save';

const required = value => value ? undefined : 'Required'

const DriverEmployerAddOrUpdate = ({ handleSubmit, setMapData, status, address, dataInfo }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);
    const apaFrameRef = useRef(null);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleFindLocation = () => {
        toggleModal();
        handleMessageToIframe();
    };

    const handleMessageToIframe = () => {
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);

                    if (buildingName && buildingName?.Value !== "") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    }
                    if (buildingName?.Value === "" && landmark?.Value !== "") {
                        deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street) {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string', error);
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-2 bg-light">
            <Col lg={12} md={12}>
                {/* Agency Information Section */}
                <Card className="border-0 shadow-sm mb-2">
                    <CardBody className="p-2">
                        <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                            <BusinessIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                            <h6 className="m-0 fw-bold small text-uppercase">Agency Information</h6>
                        </div>
                        <Row className="g-2 mb-2">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Agency Name <span className='text-danger'>*</span></label>
                                    <Field name="employerName" component={renderField} type="text" placeholder="Agency Name" validate={[required]} icon={BusinessIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Contact Name <span className='text-danger'>*</span></label>
                                    <Field name="contactPersonName" component={renderField} type="text" placeholder="Contact Name" validate={[required]} icon={PersonIcon} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="g-2 mb-2">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile Number <span className='text-danger'>*</span></label>
                                    <Field name="mobileNo" component={renderField} type="text" placeholder="971xxxxxxx" validate={[required, mobileNoFormat, mobileNoLength]} icon={SmartphoneIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Landline No.</label>
                                    <Field name="landLineNo" component={renderField} type="text" placeholder="04xxxxxxx" validate={[isNumber, validateUaeLandline]} icon={LocalPhoneIcon} />
                                </div>
                            </Col>
                        </Row>
                        {dataInfo && (
                            <Row className="g-2 mb-2">
                                <Col lg={6} md={6}>
                                    <div className="mb-1">
                                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Agency Code <span className='text-danger'>*</span></label>
                                        <Field name="employerCode" component={renderField} type="text" placeholder="Agency Code" validate={[required]} disabled={true} icon={BadgeIcon} />
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card>

                {/* Address & Settings Section */}
                <Card className="border-0 shadow-sm mb-2">
                    <CardBody className="p-2">
                        <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                            <LocationOnIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                            <h6 className="m-0 fw-bold small text-uppercase">Location & Status</h6>
                        </div>
                        <Row className="g-2 align-items-center">
                            <Col md={9}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Agency Address</label>
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                                            <LocationOnIcon style={{ fontSize: '1rem' }} />
                                        </span>
                                        <input
                                            className="form-control form-control-sm border-start-0"
                                            name="address"
                                            type="text"
                                            value={isAddress || address || ''}
                                            placeholder="Agency Address"
                                            readOnly
                                            style={{ fontSize: '0.85rem' }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={handleFindLocation}
                                            style={{ fontSize: '0.75rem', padding: '0.25rem 0.75rem' }}
                                        >
                                            <AddLocationAltIcon style={{ fontSize: '1rem' }} className="me-1" />
                                            Find Location
                                        </button>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="mb-1 text-center font-weight-bold">
                                    <label className="form-label fw-bold text-muted small mb-1 d-block" style={{ fontSize: '0.7rem' }}>OPERATIONAL STATUS</label>
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked={status}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

            <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
                    style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
                >
                    <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
                    Submit
                </Button>
            </div>

            <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl" style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}>
                    <div className="d-flex align-items-center">
                        <LocationOnIcon className="me-2 text-success" style={{ fontSize: '1.5rem' }} />
                        <b>Find Location</b>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={apaIframeUrl} width="100%" height="650px" title="Get Address" onLoad={handleMessageToIframe} style={{ border: 'none', borderRadius: '8px' }}></iframe>
                </ModalBody>
            </Modal>
        </form>
    );
};

DriverEmployerAddOrUpdate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
    if (data && data.dataInfo) {
        return {
            initialValues: {
                driverEmployerId: data.dataInfo.driverEmployerId,
                employerCode: data.dataInfo.employerCode,
                mobileNo: data.dataInfo.mobileNo,
                employerName: data.dataInfo.employerName,
                contactPersonName: data.dataInfo.contactPersonName,
                address: data.dataInfo.address,
                landLineNo: data.dataInfo.landLineNo,
                status: data.dataInfo.status,
            }
        }
    }
    return {};
}

export default connect(mapStateToProps)(reduxForm({ form: 'DriverEmployerAddOrUpdateForm', enableReinitialize: true })(DriverEmployerAddOrUpdate));